<template>
  <div class="conditions">
    <draggable group="btnList" v-model="rule.conditions" :animation="100">
      <div class="condition" v-for="(condition, index) in rule.conditions" :key="index">
        <div class="drag-icon"><svg-icon icon-class="svgo_drag"></svg-icon></div>
        <el-input
          v-model="condition.startValue"
          class="value right"
          placeHolder="无限制"
          type="number"
        ></el-input>
        <el-select v-model="condition.startMethod" class="method right" placeholder="请选择">
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="right">指标值</span>
        <el-select v-model="condition.endMethod" placeholder="请选择" class="method right">
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="condition.endValue"
          class="value right"
          type="number"
          placeHolder="无限制"
        ></el-input>
        <condition-color-popper
          :cur-data="{ background: condition.background, color: condition.color }"
          @changeData="changeData($event, condition)"
        ></condition-color-popper>
        <i class="el-icon-delete" style="font-size: 15px" @click="delCondition(index)"></i>
      </div>
    </draggable>
    <el-button type="text" @click="addCondition">添加条件</el-button>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { presetColors, methods } from "@/views/Backend/Admin/Statistics/chartEdit/static"
import ConditionColorPopper from "@/components/BaseComponents/ConditionColorPopper"
export default {
  name: "conditions",
  components: {
    ConditionColorPopper,
    draggable
  },
  props: {
    rule: Object
  },
  data() {
    return {
      presetColors,
      methods
    }
  },
  methods: {
    addCondition() {
      let length = this.rule.conditions.length
      let curColor = this.presetColors[length % 10]
      let last = {}
      if (length) {
        last = this.rule.conditions[length - 1]
      }
      this.rule.conditions.push(
        Object.assign(
          { startValue: last?.endValue || null, startMethod: "<=", endValue: null, endMethod: "<" },
          curColor
        )
      )
    },
    delCondition(index) {
      this.rule.conditions.splice(index, 1)
    },
    changeData(item, condition) {
      Object.assign(condition, item)
    }
  }
}
</script>

<style lang="scss" scoped>
.conditions {
  .condition {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    background-color: #f5f5f5;
    border-radius: 4px;
    height: 36px;
    .drag-icon {
      margin: 0 4px;
    }
    .value {
      width: 80px;
    }
    .method {
      width: 60px;
    }
    .right {
      margin-right: 4px;
    }
  }
  ::v-deep {
    .el-input__inner {
      border: unset;
      border-radius: unset;
      padding: 0 2px 0 10px;
    }
    .el-popover__reference-wrapper {
      .color {
        width: 22px;
        height: 22px;
        margin-right: 6px;
        margin-left: 3px;
        border-radius: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #e9e9e9;
        cursor: pointer;
      }
    }
  }
}
</style>
